import React from "react"
import useTranslate from "./useTranslate"

export { useTranslate } from "./useTranslate"

const withTranslate =
  <P extends object>(PassedComponent: React.ComponentType<P>) =>
  (props: P) => {
    const { ready, ...rest } = useTranslate()

    if (!ready) {
      return null
    }

    return <PassedComponent {...props} {...(rest as Record<string, unknown>)} />
  }

export default withTranslate
